export default __webpack_public_path__ + "static/media/412.d902eedb.png";